var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-center report-summary-group"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.reportData[_vm.group].title))]),_c('h3',{staticClass:"score"},[_vm._v(_vm._s(_vm.percent)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }